export default {
  authentication: {
    components: {
      forgottenPassword: {
        backButtonText: 'Wróć'
      },
      login: {
        emailAccount: {
          backButtonText: 'Wróć'
        }
      },
      registration: {
        contactPreferences: {
          skipButtonText: 'Pomiń ten krok'
        },
        createAccount: {
          backButtonText: 'Wróć'
        }
      }
    },
    hooks: {
      useAccountLogin: {
        error: {
          submissionError: {
            message: 'Twój email i/lub hasło są nieprawidłowe. Spróbuj raz jeszcze lub wybierz „Zapomniałem hasła"'
          }
        }
      },
      useAuthPageProps: {
        landing: {
          heading: 'Utwórz konto.',
          title: 'Utwórz konto'
        },
        loginLanding: {
          heading: 'Zaloguj się.',
          title: 'Zaloguj się'
        },
        loginForm: {
          heading: 'Zaloguj się.',
          title: 'Zaloguj się'
        },
        loginVerifyAccount: {
          heading: '_TODO: Your account is not yet verified.',
          title: '_TODO: Verification required'
        },
        createAccount: {
          heading: 'Utwórz konto.',
          title: 'Utwórz konto'
        },
        resetPassword: {
          heading: 'Stwórz nowe hasło.',
          title: 'Stwórz nowe hasło'
        },
        changeEmailConfirmation: {
          heading: '_TODO: Enter your password.',
          title: '_TODO: Enter your password'
        },
        contactPreferences: {
          heading: 'Bądźmy w kontakcie.',
          title: 'Bądźmy w kontakcie.'
        },
        forgottenPassword: {
          heading: 'Zapomniałes hasła?',
          title: 'Zapomniałes hasła?'
        },
        emailSentConfirmation: {
          verifyAccount: {
            heading: 'Zweryfikujmy Twoje konto.',
            title: 'Zweryfikuj swoje konto'
          },
          resetPassword: {
            heading: 'Sprawdź swoją skrzynkę email.',
            title: 'Sprawdź swoją skrzynkę email'
          }
        },
        success: {
          "default": {
            heading: 'Wszystko gotowe i gotowe!',
            title: 'Wszystko gotowe i gotowe!'
          },
          accountAlreadyVerified: {
            heading: 'Twoje konto zostało już zweryfikowane.',
            title: 'Twoje konto zostało już zweryfikowane'
          },
          loginAccountVerified: {
            heading: 'Twoje konto zostało zweryfikowane.',
            title: 'Twoje konto zostało zweryfikowane'
          },
          resetPassword: {
            heading: 'Twoje hasło zostało zmenione.',
            title: 'Twoje hasło zostało zmenione'
          }
        },
        error: {
          "default": {
            heading: 'Utwórz konto.',
            title: 'Coś poszło nie tak'
          },
          errorWithRetrySignUp: {
            heading: 'Coś poszło nie tak.',
            title: 'Coś poszło nie tak'
          },
          errorWithResendEmail: {
            heading: 'Coś poszło nie tak.',
            title: 'Coś poszło nie tak'
          },
          linkExpiredWithResendEmail: {
            heading: 'Link weryfikacyjny wygasł.',
            title: 'Link weryfikacyjny wygasł'
          },
          loginGeneralError: {
            heading: 'Zaloguj się.',
            title: 'Coś poszło nie tak'
          },
          loginVerificationErrorWithRetry: {
            heading: 'Coś poszło nie tak.',
            title: 'Coś poszło nie tak'
          },
          loginVerificationErrorWithResendEmail: {
            heading: 'Coś poszło nie tak.',
            title: 'Coś poszło nie tak'
          },
          loginVerificationLinkExpiredWithResendEmail: {
            heading: 'Link weryfikacyjny wygasł.',
            title: 'Link weryfikacyjny wygasł'
          },
          passwordResetTokenExpired: {
            heading: 'Link do hasła wygasł.',
            title: 'Link do hasła wygasł'
          }
        }
      },
      useAuthStatusProps: {
        success: {
          login: {
            accountVerified: {
              buttonText: 'Zaloguj się',
              heading: 'Udało sie!'
            }
          },
          registration: {
            buttonText: 'Powrót do początku',
            buttonTextLogin: 'Kliknij tutaj aby się zalogować',
            heading: 'Sukces!',
            subheading: 'Zalogowany jako:'
          },
          resetPassword: {
            buttonText: 'Zaloguj się na Twoje konto',
            loggedInButtonText: 'Gotowe',
            contentPartOne: 'Możesz zmienić Twoje hasło w każdej chwili w',
            contentPartTwo: 'ustawieniach konta'
          }
        },
        error: {
          registration: {
            buttonText: 'Spróbuj jeszcze raz',
            heading: 'Coś poszło nie tak',
            subheading: 'Spróbuj jeszcze raz założyć konto.'
          },
          resetPassword: {
            withRetry: {
              buttonText: 'Spróbuj ponownie',
              content: 'Kliknij poniżej, żeby spróbować ponownie.'
            },
            withResendEmail: {
              buttonText: 'Wyślij ponownie wiadomość',
              content: 'Przepraszamy za to! Spróbuj kliknąć poniżej, aby wysłać nową wiadomość weryfikacyjną.'
            },
            tokenExpired: {
              buttonText: 'Wyślij ponownie wiadomość',
              content: 'Link, który wysłaliśmy jest już nieważny. Robimy to, aby zapewnić bezpieczeństwo Twojego konta. Kliknij poniżej, aby wysłać nową wiadomość weryfikacyjną.'
            }
          },
          login: {
            generalLoginError: {
              heading: '_TODO: Something didn\'t go quite right',
              subheading: '_TODO: Please try logging in again later',
              buttonText: '_TODO: Try again'
            },
            verificationErrorWithResendEmail: {
              buttonText: 'Wyślij ponownie email weryfikacyjny',
              content: 'Przepraszamy za to! Spróbuj kliknąć poniżej, aby wysłać nową wiadomość weryfikacyjną.'
            },
            verificationErrorWithRetry: {
              buttonText: 'Spróbuj ponownie ',
              content: '_TODO: We\'ve encountered an issue while attempting to verify your account. Please try logging in again and we\'ll send you a new verification email. Alternatively, contact support at the address below.'
            },
            verificationLinkExpiredWithResendEmail: {
              buttonText: 'Wyślij ponownie email weryfikacyjny',
              content: 'Link, który wysłaliśmy jest już nieważny. Robimy to, aby zapewnić bezpieczeństwo Twojego konta. Kliknij poniżej, aby wysłać nową wiadomość weryfikacyjną.'
            },
            verificationRequired: {
              buttonText: 'Wyślij ponownie email weryfikacyjny',
              content: 'Właśnie wysłalismy link do weryfikacji Twojego konta w celu zapewnienia bezpieczeństwa. W przypadku jego wygaśnięcia, naciśnij poniżej, aby wysłać ponownie nowy link.'
            }
          }
        }
      },
      useChangeEmailConfirmation: {
        error: {
          submissionError: {
            incorrectPassword: '_TODO: Your password is incorrect'
          }
        }
      },
      useStepperProps: {
        steps: {
          first: 'Zapisać się',
          second: 'Preferencje',
          third: 'Kompletny'
        }
      }
    },
    toastNotifications: {
      success: {
        genericEmailReSent: 'Email został wysłany ponownie.',
        verificationEmailReSent: 'E-mail weryfikacyjny został wysłany ponownie.'
      },
      error: {
        verificationEmailFailed: '_TODO: Failed to send verification email.'
      }
    }
  },
  myHub: {
    account: {
      header: '_TODO: My Account',
      details: {
        header: '_TODO: My Details',
        basicInformationSectionHeader: '_TODO: Basic information',
        accountManagementSectionHeader: '_TODO: Account management'
      }
    },
    collection: {
      calloutText: 'Zapisz elementy i stwórz kolekcje na darmowym koncie',
      errorMessage: 'Nie można pobrać kolejnych elementów. Spróbuj jeszcze raz później.',
      loadNext: 'Załaduj następne',
      // v4 plural
      taglineItem_one: 'element',
      taglineItem_few: 'elementy',
      taglineItem_many: 'elementów',
      taglineItem_other: 'elementów',
      // v3 plural
      taglineItem: 'element',
      taglineItem_plural: 'elementów',
      taglineItem_0: 'element',
      taglineItem_1: 'elementy',
      taglineItem_2: 'elementów'
    },
    collections: {
      taglineSaved: 'zapisane',
      createButtonText: 'Utwórz nową kolekcję',
      loadErrorMessage: 'Nie można pobrać kolejnych elementów. Spróbuj jeszcze raz później.',
      loadNext: 'Załaduj następne',
      // v4 plural
      tagline_one: 'kolekcja',
      tagline_few: 'kolekcje',
      tagline_many: 'kolekcji',
      tagline_other: 'kolekcji',
      // v3 plural
      tagline: 'kolekcja',
      tagline_plural: 'kolekcje',
      tagline_0: 'kolekcja',
      tagline_1: 'kolekcje',
      tagline_2: 'kolekcji'
    },
    components: {
      myAccount: {
        details: {
          layoutTitle: '_TODO: My Account',
          layoutSubtitle: '_TODO: My Details',
          basicInfoSection: {
            title: '_TODO: Basic info',
            editButtonLabel: '_TODO: Click here to edit'
          }
        }
      },
      savedItem: {
        card: {
          ariaLabel: {
            save: 'Zapisz',
            unsave: 'Cofnij zapis'
          }
        }
      },
      searchFilter: {
        ariaLabel: {
          searchButton: 'szukaj'
        },
        filteredResultsHeading: 'Wyniki dla:',
        sr: {
          // v4 plural
          filteredItemsResults_one: 'wynik',
          filteredItemsResults_few: 'wyniki',
          filteredItemsResults_many: 'wyników',
          filteredItemsResults_other: 'wyniki',
          // v3 plural
          filteredItemsResults: 'wynik',
          filteredItemsResults_plural: 'wyniki',
          filteredItemsResults_0: 'wyniki',
          filteredItemsResults_1: 'wynik',
          filteredItemsResults_2: 'wyników'
        }
      }
    },
    hooks: {
      useResponseCodes: {
        firstName: {
          tooLong: '_TODO: First name must be no longer than 100 characters'
        },
        lastName: {
          tooLong: '_TODO: Last name must be no longer than 100 characters'
        },
        screenName: {
          notUnique: '_TODO: This screen name is already taken',
          tooLong: '_TODO: Screen name must be no longer than 100 characters'
        },
        email: {
          invalid: '_TODO: Please enter a valid email address',
          notUnique: '_TODO: This email address is already taken',
          tooLong: '_TODO: Email address must be no longer than 100 characters'
        }
      }
    },
    overview: {
      createButtonText: 'Utwórz nową kolekcję',
      defaultTitle: 'Moja Przestrzeń',
      ugcButtonLabel: 'Zobacz więcej',
      ugcCreateButtonText: 'Dodaj przepis'
    },
    ownItems: {
      createButtonText: 'Dodaj nowy przepis',
      loadErrorMessage: 'Nie można pobrać kolejnych elementów. Spróbuj jeszcze raz później.',
      loadNext: 'Załaduj następne',
      tabData: {
        all: 'Wszystko',
        published: 'Opublikowane',
        unpublished: 'Nieopublikowane'
      },
      tabFilterError: 'Wystąpił problem z filtrowaniem Twoich przepisów. Wyświetlamy wszystkie przepisy.'
    },
    savedItems: {
      // v4 plural
      collectionTaglineItem_one: 'element',
      collectionTaglineItem_few: 'elementy',
      collectionTaglineItem_many: 'elementów',
      collectionTaglineItem_other: 'elementów',
      // v3 plural
      collectionTaglineItem: 'element',
      collectionTaglineItem_plural: 'elementy',
      collectionTaglineItem_0: 'element',
      collectionTaglineItem_1: 'elementy',
      collectionTaglineItem_2: 'elementów',
      collectionTaglineSaved: 'zapisane',
      loadErrorMessage: 'Nie można pobrać kolejnych elementów. Spróbuj jeszcze raz później.',
      loadNext: 'Załaduj następne'
    }
  },
  nextCore: {
    signIn: {
      errorLineOne: 'Szukasz czegoś konkretnego?',
      errorLineTwo: 'Zaloguj',
      errorLineThree: 'się,',
      errorLineFour: 'żeby zobaczyć stronę.',
      errorLineFive: 'Jeszcze nie utworzyłeś swojego darmowego konta?',
      errorLineSix: 'Dołącz do nas'
    }
  },
  postCreator: {
    confirmation: {
      metaTitle: 'Utwórz przepis - Dziękuję',
      newRecipeButtonText: 'Nowy przepis',
      ownRecipeButtonText: 'Moje Przepisy'
    },
    create: {
      metaTitle: 'Utwórz przepis'
    },
    edit: {
      editFormTitle: 'Edytuj przepis',
      metaTitle: 'Edytuj przepis'
    },
    recipeDetails: {
      dropDownOptions: {
        hours: 'godziny',
        mins: 'min'
      },
      heading: 'Szczegóły przepisu',
      label: {
        cookTime: 'Czas gotowania (średnio)',
        difficulty: 'Poziom trudności',
        extraTime: 'Dodatkowy czas (opcjonalnie)',
        image: 'Obrazek',
        prepTime: 'Czas przygotowania (średnio)',
        servings: 'Porcje',
        shortIntro: 'Krótkie wprowadzenie (10-15 słów)',
        title: 'Tytuł przepisu (krótki i opisowy)'
      },
      placeholder: {
        extraTime: 'np. plus przerwa',
        makes: 'np. 8 kawałków',
        serves: 'np. 4',
        shortIntro: 'Opowiedz nam o swoim przepisie',
        title: 'np. Szarlotka mamy'
      },
      servingsButton: {
        makes: 'Robić',
        serves: 'Dostarczać'
      },
      skillLevel: {
        dropDownOptions: {
          challenge: 'Wyzwanie',
          defaultText: '(Wybierz z listy)',
          easy: 'Łatwy',
          moreEffort: 'Więcej wysiłku'
        }
      }
    },
    recipeForm: {
      defaultFeedback: {
        error: 'Ups! Coś poszło nie tak',
        info: 'Zachowaj obrazek przed wysłaniem'
      },
      links: {
        back: 'Powrót do moich przepisów',
        preview: 'Podgląd',
        saveDraft: 'Zachowaj szkic'
      }
    },
    recipeIngredients: {
      heading: 'Składniki',
      information: {
        lineOne: 'Możesz podzielić swoje składniki na grupy np. sos, nadzienie itd.',
        lineTwo: 'z naszego',
        lineThree: 'przelicznika)',
        lineFour: 'Możesz podzielić swoje składniki na grupy np. sos, nadzienie itd.)'
      },
      ingredient: {
        buttonText: 'Dodaj kolejny składnik',
        label: 'Składnik',
        placeholder: '500g udek z kurczaka, pokrojonych w kostkę'
      },
      ingredientGroup: {
        buttonText: 'Dodaj nagłówek grupujący',
        heading: 'Nagłówek',
        placeholder: 'Do sosu'
      }
    },
    recipeMethodSteps: {
      heading: 'Metoda',
      method: {
        buttonText: 'Dodaj kolejny krok',
        label: 'Krok',
        placeholder: 'Najpierw ugotuj ryż'
      }
    },
    statusFeedback: {
      createLinkeText: 'stworzyć nowy przepis',
      info: {
        approved: 'Twój przepis został zatwierdzony',
        "default": 'Ups, coś poszło źle',
        draft: 'Twój przepis nie został jeszcze wysłany',
        pending: 'Twój przepis nie został jeszcze wysłany',
        rejected: 'Twój przepis nie został zatwierdzony'
      },
      submissionChoice: {
        approved: 'zobaczyć swój przepis',
        "default": 'wrócić do listy przepisów',
        draft: 'edytować swój przpeis',
        heading: 'A może chcesz'
      },
      submittedText: 'Twój przepis został wysłany do zatwierdzenia i nie możesz go edytować.'
    },
    submit: {
      formValidation: {
        defaultMessage: 'Potwierdź, że zapoznałeś się z zasadami i warunkami'
      },
      informationLineOne: 'Pamiętaj, żeby dodawać tylko własne przepisy.',
      informationLineTwo: 'Ze względu na prawa autorskie nie możemy opublikować żadnego z  przepisów',
      informationLineThree: 'dodanych przez naszych czytelników, które zostały stworzone przez osoby trzecie. Zanim wyślesz przepis przeczytaj nasze',
      informationLineFour: 'zasady i warunki,',
      informationLineFive: 'aby uzyskać więcej informacji.',
      metaTitle: 'Utwórz przepis - Zasady i warunki',
      previewButtonText: 'Podgląd',
      publishButtonText: 'Opublikuj',
      termsLabel: 'Zaznacz, że zapoznałeś się z naszymi zasadami i warunkami.'
    }
  }
};